export function NotesField() {
  return (
    <div className="config-group" style={{ marginTop: '20px' }}>
      <label data-ar="ملاحظات إضافية" data-en="Additional Notes" htmlFor="quoteNotes">Additional Notes</label>
      <textarea
        className="quote-notes-input"
        data-placeholder-ar="أضف أي تعليمات أو ملاحظات خاصة بطلبك"
        data-placeholder-en="Add any special instructions or notes for your request"
        id="quoteNotes"
        name="notes"
        placeholder="Add any special instructions or notes for your request"
        rows={4}
      />
    </div>
  );
}
